/* Referral capture (Phase 3). On a ?ref=CODE landing, store the code as a cart
   note attribute so it lands on the order (read by the orders/create webhook). */
(function () {
  "use strict";
  var m = location.search.match(/[?&]ref=([^&]+)/);
  var code = null;
  if (m) {
    code = decodeURIComponent(m[1]);
    try { localStorage.setItem("ref_code", code); } catch (e) {}
  } else {
    try { code = localStorage.getItem("ref_code"); } catch (e) {}
  }
  if (!code) return;
  fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ attributes: { ref: code } })
  }).catch(function () {});
})();
